import { render, staticRenderFns } from "./LocalGrid.vue?vue&type=template&id=77afceb2"
import script from "./LocalGrid.vue?vue&type=script&lang=js"
export * from "./LocalGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports